// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Experience-module--cds--assistive-text--d56f9";
export var cdsVisuallyHidden = "Experience-module--cds--visually-hidden--5b46d";
export var experience = "Experience-module--experience--cd0c8";
export var experienceContainer = "Experience-module--experience-container--de5fd";
export var hideFeedback = "Experience-module--hide-feedback--b43a8";
export var selected = "Experience-module--selected--9ed62";
export var showFeedback = "Experience-module--show-feedback--e088e";
export var skeleton = "Experience-module--skeleton--eb704";